<template>
	<div style="background-color: #fff;padding: 10px;margin-bottom: 4px;" class="tag_view" v-show="showTags">
		<TransitionGroup name="list">
			<el-tag class="click" size="large" :bordered="false" style="margin-right: 5px;" @click="tagClick(item)"
				@close="layoutStore.removeTag(item.path)" closable :type="item.isActivity ? 'primary' : 'info'"
				v-for="(item, index) in layoutStore.tags" :key="index">
				{{ item.meta.title }}
			</el-tag>
		</TransitionGroup>
	</div>
</template>

<script>
import { useRouter } from 'vue-router'
import { useLayoutStore } from "../../../../stores/layout"

export default {
	setup() {
		const router = useRouter()
		const layoutStore = useLayoutStore()

		return {
			router,
			layoutStore
		}
	},
	computed: {
		showTags() {
			if (!this.layoutStore.showTags) {
				return false
			}
			if (Object.keys(this.layoutStore.tags).length > 0) {
				return true
			}
			return false
		},
	},
	methods: {
		tagClick(item) {
			this.router.push(item.path)
		},
	}
}
</script>

<style scoped lang="less">
.list-move,
/* 对移动中的元素应用的过渡 */
.list-enter-active,
.list-leave-active {
	transition: all 0.2s ease;
}

.list-enter-from,
.list-leave-to {
	opacity: 0;
	transform: translateX(-50px);
}

/* 确保将离开的元素从布局流中删除
	  以便能够正确地计算移动的动画。 */
.list-leave-active {
	position: absolute;
}
</style>